import React, { Suspense, useContext, useEffect } from 'react';
import tw from 'twin.macro';
import { Ads, setAdsHeightPlaceholder, SideBarAds } from '../ads';
import { LoadingDots } from '../loading';
import { ScrollBarContent } from '../scroll';
import { AppContext } from '../context';
import { useMounted } from '../common/hooks';
import { ItemContext } from '../item';
import { Comments } from '../comments';

export const SideBarComments = ({ notSticky = false, hideAds = false, ...restProps }) => {
  const { currentItemId, item } = useContext(ItemContext);

  const { windowSize } = useContext(AppContext);
  const isMounted = useMounted();

  const { slideIn, twitchLiveStream } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => setAdsHeightPlaceholder(document.querySelector('[id$="-t2"]')), 5000);
  }, []);

  return (
    <>
      {currentItemId && (
        <>
          {!twitchLiveStream && (
            <Suspense fallback={<LoadingDots />}>
              {!['DESKTOP'].includes(windowSize.adBreakPoint) && (
                <div>
                  <Comments itemId={currentItemId} item={item} />
                </div>
              )}
              {['DESKTOP'].includes(windowSize.adBreakPoint) && (
                <ScrollBarContent
                  css={[
                    tw`block`,
                    !notSticky &&
                      tw`overflow-y-scroll overflow-x-hidden lg:mx-0 top-0 md:z-30 flex-grow-0 lg:overflow-hidden lg:sticky`,
                    slideIn.active && !notSticky && tw`top-0 lg:h-[calc(100vh - 5rem)]`,
                    !slideIn.active && !notSticky && tw`md:top-14 lg:h-[calc(100vh - 4.5rem)]`,
                  ]}
                  {...restProps}
                >
                  <div
                    tw='h-full scrollbar-thin scrollbar-thumb-icons scrollbar-track-primary
                  scrollbar-thumb-rounded-full scrollbar-track-rounded-full pr-2 overflow-x-hidden overflow-y-scroll'
                  >
                    {['DESKTOP'].includes(windowSize.adBreakPoint) && !hideAds && (
                      <Ads
                        Type={SideBarAds}
                        adType={windowSize.height >= 1070 ? 'halfpageskyscraper' : 'largerectangle'}
                        adNumber='t2'
                        collapsed
                      />
                    )}
                    <Comments itemId={currentItemId} item={item} />
                    {['DESKTOP'].includes(windowSize.adBreakPoint) && !hideAds && (
                      <div tw='mt-4'>
                        <Ads
                          Type={SideBarAds}
                          adType='halfpageskyscraper'
                          adNumber='b1'
                          collapsed
                        />
                        <hr tw='border-icons opacity-20 mt-4' />
                      </div>
                    )}
                  </div>
                </ScrollBarContent>
              )}
            </Suspense>
          )}

          {twitchLiveStream && isMounted && (
            <iframe
              id='twitch-chat-embed'
              src={`https://www.twitch.tv/embed/dumpert/chat?parent=${window.location.hostname}`}
              height='750px'
              width='100%'
            ></iframe>
          )}
        </>
      )}
    </>
  );
};
